const Product = {
  log: window.log,

  init() {
    this.calculateDeliveryDate(1);
    this.variantSelector();
    this.initUpdate();
    this.addToCart();
    this.updateATCPriceFromKaching();
  },

  calculateDeliveryDate(daysToAdd) {
    const currentDate = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const addBusinessDays = (startDate, numDays) => {
      const resultDate = new Date(startDate);
      let addedDays = 0;
      while (addedDays < numDays) {
        resultDate.setDate(resultDate.getDate() + 1);
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return resultDate;
    };

    const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
    const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
    $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
  },

  currency: ($('#variants-data').data('currency')).match(/[^\d.,\s]+/g)?.[0] || '£',
  color: $('.pdp-main__product-option.color.active').data('color'),
  size: $('.pdp-main__product-option.size.active').data('size') || $('.pdp-main__product-options-select.main-select .main-select__item[data-selected="true"]').data('value') || $('.pdp-main__product-dropdown').val() || $('.pdp-main__product-options-dropdown__item[data-selected="true"]').data('size'),
  klarna: $('.pdp-main__klarna span'),
  kachingQuantity: $('.kaching-bundles__bar--selected').find('.kaching-bundles__bar-title').text().match(/\d+/)?.[0] || 1,
  state: {
    imagesState: {
      originalSrcsets: null,
      originalAlts: null
    }
  },

  getLabel(group) {
    return group === 'color'
      ? $('.pdp-main__product-option.color.active h4').text()
      : $('.pdp-main__product-option.size.active').text() || $('.pdp-main__product-options-select.main-select .main-select__item[data-selected="true"] .item-label').text() || $('.pdp-main__product-options-select option:selected').text() || $('.pdp-main__product-options-dropdown__item[data-selected="true"]').find('.item-label').text().trim();
  },
  updateLabel(group) {
    $(`.pdp-main__product-options-label.${group} span`).text(this.getLabel(group));
  },

  get selectedVar() {
    const baseQuery = '#variants-data .variant-data';
    const query = baseQuery + `[data-color="${this.color}"]${this.size ? `[data-size="${this.size}"]` : ''}`;

    const selected = $(query);
    window.product_selected_variant = selected.length ? selected : $(baseQuery);
    return selected.length ? selected : $(baseQuery);
  },

  // Helper function to update main price display
  updateMainPriceDisplay(originalPrice, discountedPrice, saveAmount, savePercentage) {
    const priceClass = '.pdp-main__prices';
    $(`${priceClass} s`).text(`${this.currency}${originalPrice}`);
    $(`${priceClass} h3`).text(`${this.currency}${discountedPrice}`);
    $(`${priceClass} p .discount-value`).text(`${this.currency}${saveAmount}`);
    $(`${priceClass} p .discount-percentage`).text(`${savePercentage}%`);
  },

  updatePrice() {
    const selectedVar = this.selectedVar;
    if (selectedVar.length) {
      const price = (selectedVar.data('price') / 100).toFixed(2);
      const comparePrice = (selectedVar.data('compare-price') / 100).toFixed(2);

      const saveAmount = (comparePrice - price).toFixed(2);
      const savePercentage = ((comparePrice - price) / comparePrice * 100).toFixed();
      const klarnaPrice = (price / Number(this.klarna.data('divide'))).toFixed(2);

      // Handle stock status
      const stock = parseInt(selectedVar.data('stock'));
      const available = !!selectedVar.data('available');
      if (stock <= 0 && !available) {
        $('.pdp-main__atc-btn').addClass('soldout').find('span:not(.money)').text('Sold Out');
        $('.pdp-main__atc-btn').find('.money').text('');
      } else {
        const atcMainText = $('.pdp-main__atc-btn').find('span:not(.money)').data('main-text');
        $('.pdp-main__atc-btn').removeClass('soldout').find('span:not(.money)').text(atcMainText);
        $('.pdp-main__atc-btn').find('.money').text(`${this.currency}${price * this.kachingQuantity}`);
      }

      this.updateMainPriceDisplay(comparePrice, price, saveAmount, savePercentage);

      if (this.klarna.length > 0) this.klarna.text(`${this.currency}${klarnaPrice}`);
    }
  },

  updateATCPriceFromKaching() {
    const setATCPrice = (selectedOption) => {
      const priceText = selectedOption.find('.kaching-bundles__bar-price').text().trim(),
        titleText = selectedOption.find('.kaching-bundles__bar-title').text()
      this.kachingQuantity = parseInt(titleText.match(/\d+/)?.[0], 10) || 1;
      const m = priceText.match(/^([^\d.,]*)([\d.,]+)(?:\s*([^\d.,]+))?$/);
      const n = m ? parseFloat(m[2].replace(',', '.')) : 0;
      const formatted = m ? `${m[1]}${(n * this.kachingQuantity).toFixed(2).replace(/\.00$/, '')}${m[3] ? ' ' + m[3].trim() : ''}` : '';
      $('.pdp-main__atc-btn').find('.money').text(formatted);
    }

    setATCPrice($('.kaching-bundles__bar--selected')); // Initial set
    $('.kaching-bundles__bar').on('click', (e) => {
      const selectedOption = $(e.currentTarget);
      setATCPrice(selectedOption);
    });
  },

  updateImages(color) {
    const imageContainer = $('.pdp-main__images .product-images[data-images="all"]');
    const isCarouselSlick = imageContainer.hasClass('slick-initialized');

    if (isCarouselSlick) {
      // If carousel is initialized, just go to the correct slide
      const selectedVarIndex = imageContainer.find(`div:has(> img[data-variant="${color}"])`).data('index');
      if (selectedVarIndex !== undefined) {
        imageContainer.slick('slickGoTo', selectedVarIndex);
      }
    } else {
      // If not initialized, handle srcset/alt switching
      const firstImage = imageContainer.find('img').first();
      const colorSrcset = firstImage.attr(`data-${color}-srcset`);

      if (colorSrcset) {
        // Initialize state if needed
        if (!this.state.imagesState.originalSrcsets) {
          this.state.imagesState.originalSrcsets = new Map();
          this.state.imagesState.originalAlts = new Map();
          imageContainer.find('img').each((_, img) => {
            const $img = $(img);
            const variant = $img.attr('data-variant');
            if (variant) {
              this.state.imagesState.originalSrcsets.set(variant, $img.attr('srcset'));
              this.state.imagesState.originalAlts.set(variant, $img.attr('alt'));
            }
          });
        }

        // Reset all images to original state
        imageContainer.find('img').each((_, img) => {
          const $img = $(img);
          const variant = $img.attr('data-variant');
          if (variant && this.state.imagesState.originalSrcsets.has(variant)) {
            const originalSrcset = this.state.imagesState.originalSrcsets.get(variant);
            const originalAlt = this.state.imagesState.originalAlts.get(variant);
            $img.attr({
              srcset: originalSrcset,
              alt: originalAlt
            });
          }
        });
        // Swap first image with variant image
        const variantImage = imageContainer.find(`img[data-variant="${color}"]`);

        if (variantImage.length) {
          const firstImageState = {
            srcset: firstImage.attr('srcset'),
            alt: firstImage.attr('alt')
          };
          variantImage.attr({
            srcset: firstImageState.srcset,
            alt: firstImageState.alt
          });
          firstImage.attr({
            srcset: colorSrcset,
            alt: `${firstImage.attr('data-alt')} ${color.charAt(0).toUpperCase() + color.slice(1)}`
          });
        }
      }
    }
  },

  updateMiniReview() {
    $('.pdp-image__mini-review-description').each(function () {
      const $desc = $(this), $svg = $desc.find('svg');
      if (!$svg.length) return;
      if (!$desc.find('p').length) $desc.wrapInner('<p/>');
      $svg.appendTo($desc.find('p'));
    });
  },

  updateNote: color => $('.pdp-main__price-note').toggleClass('hidden', color === 'gold-24k'),

  handleize(str) {
    return str.toLowerCase().replace(/ /g, '-').replace(/\./g, '-').replace(/[^\w-]+/g, '').replace(/-+/g, '-');
  },

  handleKachingBundle() {
    const selectedOption = $('.kaching-bundles__bar--selected');
    const selectedDealId = selectedOption.attr('data-deal-bar-id');
    const optionVariants = selectedOption.find('.kaching-bundles__bar-variants');
    const freeGiftLink = selectedOption.find('a.kaching-bundles__free-gift__link');
    const kachingFreeGiftData = $('kaching-bundles-block').attr('other-products');
    const kachingDealBlockData = $('kaching-bundles-block').attr('deal-block');
    if (!kachingDealBlockData) return [[], false];
    const kachingDealData = JSON.parse(kachingDealBlockData).dealBars.find(deal => deal.id === selectedDealId);
    this.log.collapse({ kachingDealData, selectedDealId }, "Kaching Deal Data", "info");

    if (!optionVariants.length && !kachingFreeGiftData) return [[], false];
    const replaceItems = !!optionVariants.length;

    // Important properties for all the discounts of the bundle to work
    const productForm = $('form[is="product-form"]');
    let mainProperties = productForm.find('input[name="properties[__kaching_bundles]"]').val();
    try {
      mainProperties = mainProperties ? JSON.parse(mainProperties) : {};
    } catch (e) {
      mainProperties = {};
    }
    const formatProperties = (propertiesObj) => ({ __kaching_bundles: JSON.stringify(propertiesObj) });

    let items = [];
    const optionSelects = optionVariants.find('.kaching-bundles__bar-variant-selects');
    optionSelects.each((_, select) => { // Quantities (2 selects)
      const $select = $(select);
      const selectedColor = this.handleize($select.find('.kaching-bundles__bar-variant-select[data-name="Color"]').val());
      const selectedSize = this.handleize($select.find('.kaching-bundles__bar-variant-select[data-name="Size"]').val());
      const selectedVariant = $(`#variants-data .variant-data[data-color="${selectedColor}"]${selectedSize ? `[data-size="${selectedSize}"]` : ''}`);
      if (!selectedVariant.length) return;

      this.log.collapse({ selectedColor, selectedSize, selectedVariant, mainProperties }, "Selected Kaching Variant", "warning");
      items.push({ id: selectedVariant.data('id'), quantity: 1, properties: formatProperties(mainProperties) }); // Quantity (1 input)
    });

    if (kachingFreeGiftData) {
      const freeGiftData = JSON.parse(kachingFreeGiftData)[0]; // Array of product objects
      this.log.collapse({ freeGiftData }, "Kaching Free Gift Data", "info");

      // Skip if no free gifts available
      if (!kachingDealData?.freeGifts?.length) {
        this.log.collapse({ kachingDealData }, "No free gifts in deal, skipping", "warning");
      } else {
        const freeGiftWrap = $('.kaching-bundles__free-gift');
        const freeGiftQuantity = kachingDealData.freeGifts[0].quantity || 1;

        const selectedGiftColor = freeGiftWrap.find('.kaching-bundles__bar-variant-select[data-name="Color"]').val();
        const selectedGiftSize = freeGiftWrap.find('.kaching-bundles__bar-variant-select[data-name="Size"]').val();

        const selectedGiftVariant = freeGiftData.variants.find(variant => variant.options.includes(selectedGiftColor) && variant.options.includes(selectedGiftSize));
        if (!selectedGiftVariant) return;
        const freeGiftVariantId = selectedGiftVariant.id;

        const freeGiftPropertyId = selectedOption.find('.kaching-bundles__free-gift').data('free-gift-id');
        const giftProperties = { ...mainProperties, gift: freeGiftPropertyId };
        delete giftProperties.main; // Remove main property

        this.log.collapse({ selectedGiftVariant, freeGiftVariantId, giftProperties }, "Gift Final Data", "info");

        if (freeGiftVariantId) items.push({ id: freeGiftVariantId, quantity: freeGiftQuantity, properties: formatProperties(giftProperties) });
      }
    }

    this.log.collapse({ items, hasFreeGift: !!freeGiftLink.length, mainProperties }, "Kaching Bundle Items", "info");
    return [items, replaceItems, formatProperties(mainProperties)];
  },

  initUpdate() {
    this.selectVariantFromURL();
    this.updateVariantMetaAndURL();
    this.updatePrice();
    this.updateLabel('color');
    this.updateLabel('size');
    this.updateImages(this.color);
    this.updateNote(this.color);
    this.updateMiniReview();
  },

  variantSelector() {
    $('.pdp-main__product-option').on('click', (e) => {
      const $option = $(e.currentTarget);
      const group = $option.data('color') ? 'color' : 'size';

      $option.addClass('active').siblings(`.${group}`).removeClass('active');
      this[group] = $option.data(group);

      if (group === 'color') {
        this.updateImages(this.color);
        this.updateNote(this.color);
      }
      this.updatePrice();
      this.updateLabel(group);
      this.updateVariantMetaAndURL();
    });

    $('.pdp-main__product-options-dropdown__item').on('click', (e) => {
      const $item = $(e.currentTarget);
      if (!$item.is('[data-selected="true"]')) {
        $('.pdp-main__product-options-dropdown__item[data-selected="true"]').removeAttr('data-selected');
        $item.attr('data-selected', 'true');

        this.handleSizeVariantChange($item.data('size'));
        $('.pdp-main__product-options-dropdown').removeClass('open');
      }
    });

    $('select.pdp-main__product-options-select').on('change', (e) => {
      const $select = $(e.currentTarget);
      this.handleSizeVariantChange($select.val());
    });

    $(document).on("click", ".pdp-main__product-options-select.main-select .main-select__item", (e) => {
      this.handleSizeVariantChange($(e.currentTarget).data('value'));
    });
  },

  // Handle variant change logic
  handleSizeVariantChange(selectedValue) {
    this.size = selectedValue;
    this.updateVariantMetaAndURL();
    this.updatePrice();
    this.updateLabel('size');
  },

  selectVariantFromURL() {
    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return;
    const $variant = $(`#variants-data .variant-data[data-id="${variantId}"]`);
    if (!$variant.length) return;

    this.color = $variant.data('color') || this.color;
    this.size = $variant.data('size') || this.size;

    if (this.color) {
      $(`.pdp-main__product-option[data-color="${this.color}"]`).addClass('active').siblings('.color').removeClass('active');
    }

    if (this.size) {
      // Handle dropdown if present
      const $dropdownRadio = $(`.pdp-main__product-options-dropdown__radio[value="${this.size}"]`);
      if ($dropdownRadio.length) {
        $dropdownRadio.prop('checked', true).trigger('change');
      } else {
        $(`.pdp-main__product-option[data-size="${this.size}"]`).addClass('active').siblings('.size').removeClass('active');
      }
    }
  },

  updateVariantMetaAndURL() {
    const selectedVar = this.selectedVar;
    if (!selectedVar.length) return;

    const url = new URL(window.location.href);
    const variantColors = $(`#variants-data .variant-data[data-color="${this.color}"]${this.size ? `[data-size="${this.size}"]` : ''}`);
    const firstVariantId = variantColors.first().data('id');
    this.log.collapse({ variantColors, firstVariantId }, "Update Variant Meta and URL", "info");
    url.searchParams.set('variant', firstVariantId);

    // Update the canonical tag
    $('link[rel="canonical"]').attr('href', url.href);

    // Update the page title dynamically
    const titlePrefix = 'Shop';
    const titleSuffix = ' | Armadilo';
    let baseTitle = document.title.split(titleSuffix)[0].split(' - ')[0];
    baseTitle = baseTitle.includes(titlePrefix) ? baseTitle.split(titlePrefix)[1] : baseTitle;
    document.title = `${titlePrefix} ${baseTitle} - ${selectedVar.text()}${titleSuffix}`;

    // Push new state to browser history
    window.history.replaceState({}, '', url.href);
  },

  addToCart() {
    $('.pdp-main__atc-btn').click((e) => {
      e.preventDefault();
      const selectedVar = this.selectedVar;
      const id = selectedVar.data('id');
      if (!id) return alert('Please select a product option.');

      let items = [{ id, quantity: 1 }];
      const [bundleItems, replaceItems, mainProperties] = this.handleKachingBundle();
      if (bundleItems.length) {
        if (replaceItems) items = bundleItems;
        else {
          items = [...items, ...bundleItems];
          if (mainProperties) items.find(item => item.id === id).properties = mainProperties;
        }
      }

      $.post('/cart/add.js', { items })
        .done(() => { window.cart_open(); window.cart_build(); })
        .fail(() => alert('Error adding item to cart.'));
    });
  }
};

$(document).ready(function () {
  Product.init();
});